// extracted by mini-css-extract-plugin
export default {"page_d":"PaginationBox_page_d__3c5WW","page_l":"PaginationBox_page_l__9OMo4","active":"PaginationBox_active__PZFQ9"};